<template>
	<div class="1c_data">
		<div class="panel-tag" v-if="data.length == 0">
			Увага! Дана ЗД не перебуває в оренді підприємств ГК ІМК. Її придбання потребує отримання відмови від переважного права на придбання від поточного орендаря ЗД, а також передбачає подальші орендні взаємовідносини покупця із поточним орендарем ЗД – сторонньою компанією, яка не входить до складу ГК ІМК!
		</div>

		<div class="panel-body" v-else>

			<div class="panel-tag" v-if="has_empty_daz">
				Увага! Дана ЗД не перебуває в оренді підприємств ГК ІМК. Її придбання потребує отримання відмови від переважного права на придбання від поточного орендаря ЗД, а також передбачає подальші орендні взаємовідносини покупця із поточним орендарем ЗД – сторонньою компанією, яка не входить до складу ГК ІМК!
			</div>
			<b-row>
				<b-col sm="4" class="left_pais">
					<div class="bg-light rounded-top mb-2" v-for="(pai,idx) in this.data">
						<div id="js_list_accordion" class="accordion accordion-hover accordion-clean ">
							<div class="card ">
								<div class="card-header border">
									<a v-on:click="setActivePai(idx)" class="card-title"
									   :class="{'collapsed' : !pai.is_active, 'is_real_active border border-danger' : check_is_current(pai) }">
										<i class="fal fa-globe-americas width-2 fs-xl"></i>

										{{getOwner1c(pai)}}

										<div class="ml-2">
											<small>{{pai.params.kadastr}}</small>
										</div>

									</a>
								</div>
							</div>
						</div>
					</div>

				</b-col>

				<b-col sm="8" class="right_pais">
					<div class="1c_fields" >
						<div class="descriptions border p-3" v-if="pai_1c_active != null" >
							<div class="blck" v-if="can_show_1c_field(info)" v-for="(info) in pai_fields_active">
								<b>{{ info.field_name}}</b>
								= {{info.field_val}}
							</div>
						</div>
					</div>



				</b-col>
			</b-row>
		</div>
	</div>

</template>

<script>
export default {
	name: "data_1c",
	props : {
		"data": {
			type : Array
		},

		owner : {
			type : String,
			default : "",
		},

		addon_fields: {
			type: Array,
		}
	},

	created() {
		EventBus.$on("data_1c_loaded",this.set_default_active);
	},

	mounted() {
		console.log('%c Mounted data_1c:', "color: #1ab3a3",this.data,this.addon_fields);
		this.set_default_active();

	},
	data() {
		return {
			disabled_draw_fields : [
				'pole1koordynaty',
				'pole2koordynaty',
				'pole3koordynaty',
				'pole4koordynaty',
				'pole5koordynaty',
			]

		}
	},

	methods : {

		set_default_active() {
			let self = this;
			setTimeout(function(){
				console.log('%c Loaded data_1c:', "color: #1ab3a3",self.data,self.addon_fields);
				try {
					self.data.map((itm,idx) => {
						if(self.check_is_current(itm)) {
							self.setActivePai(idx);
						}
					});
				}
				catch (e) {
					console.log(e);
				}}, 500)
		},

		check_is_current(field) {
			try {
				if (this.pai_memorandum_active != null) {
					if(this.pai_memorandum_active.params.kontragent === field.params.kontragent) {
						return true;
					}
				}
			}
			catch (e) {

			}

			return false;

		},

		get_current_val(type) {
			let res = null;

			this.addon_fields.map(itm => {
				if(itm.field_type === type) {
					res = itm;
				}
			});

			return res;
		},

		can_show_1c_field(item) {
			let can_show = true;
			try {
				this.disabled_draw_fields.map(type => {
					if (item.field_type == type) {
						can_show = false;
					}
				})
			}
			catch (e) {

			}
			return can_show;
		},

		setActivePai (idx) {
			this.data.map(item => {
				item.is_active = false;
			})
			try {
				this.data[idx].is_active = true;
				this.$set(this.data,idx,this.data[idx]);
			}
			catch (e) {

			}
		},


		getOwner1c(field) {
			let kontr = '';
			try {
				if (field.hasOwnProperty('data_1c')) {
					let p_1c = field.data_1c;

					p_1c.map(item => {
						if(item.field_type == 'Kontrahent') {
							kontr = item.field_val;
						}
					});
				}
			}
			catch (e) {

			}
			return kontr;
		},
	},

	computed : {

		has_empty_daz() {
			let is_empty = false;
   
			try {
				if(this.pai_1c_active == null || this.pai_1c_active == undefined || this.pai_memorandum_active == null) {
					return true;
				}


				this.pai_fields_active.map(itm => {
					if(itm.field_type == 'dozkod') {
						if(itm.field_val.trim().length == 0) {
							is_empty = true;
						}
					}
				});

			}
			catch (e) {

			}

			return is_empty;
		},

		pai_fields_active() {
			let fields = [];
			if(this.pai_1c_active != null && this.pai_1c_active.hasOwnProperty("data_1c")) {
				return this.pai_1c_active.data_1c;
			}
			return fields;
		},

		pai_memorandum_active() {
			let cur = null;

			try {
				this.data.map(item => {
					let kontragent = this.owner;
					item.data_1c.map(item_1c => {
						if(item_1c.field_type === 'Kontrahent' && kontragent != null && kontragent === item_1c.field_val) {
							cur = item;
						}
					})
				});
			}
			catch (e) {
				console.log(e);
			}

			return cur;
		},

		pai_1c_active () {
			let active = null;
			try {
				this.data.map(item => {
					if (item.is_active) {
						active = item;
					}
				});
			}
			catch (e) {
				console.log(e);
			}
			return active;
		},

	}

}
</script>

<style scoped>
	.is_real_active i {
		color:red;
	}
</style>
